import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie';

export const outletApi = createApi({
  reducerPath: "outletApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
        const { auth } = getState();
        const token = Cookies.get('accessToken')
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Content-Type', `application/json;charset=UTF-8`);
        return headers;
    },
  }),
  tagTypes: ["outlet", "services"],
  endpoints: (builder) => ({
    outlets: builder.query({
      query: (data) => {
          return {
              url: "/Auth/outlets",
              method: "GET",
              params: data
          }
      },
      providesTags: ["outlet"],
    }),
    services: builder.query({
      query: (data) => {
          return {
              url: "/Auth/getServiceList",
              method: "GET",
              params: data
          }
      },
      providesTags: ["services"],
    }),
    getOutletByName: builder.query({
      query: (data) => {
          return {
              url: "/Auth/GetOutletByName",
              method: "GET",
              params: {
                outletId: data
              }
          }
      },
      providesTags: ["outlet"],
    }),
    createOutlet: builder.mutation({
      query: (data) => {
        return {
          url: "/Auth/CreateNewOutlet",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["outlet"],
    }),
    updateOutlet: builder.mutation({
      query: (data) => {
        return {
          url: "/Auth/UpdateOutlet",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["outlet"],
    }),
    deleteOutlet: builder.mutation({
      query: (data) => {
          return {
              url: `/Auth/DeleteOutlet?keyID=${data}`,
              method: "POST"
          }
      },
      invalidatesTags: ["outlet"],
    }),
    statusChange: builder.mutation({
        query: (data) => {
            return {
                url: `/Auth/updateOutletStatus`,
                method: "POST",
                body: data
            };
        },
        invalidatesTags: ["outlet"],
    }),
  }),
});

export const { useOutletsQuery, useServicesQuery, useGetOutletByNameQuery, useCreateOutletMutation, useUpdateOutletMutation, useDeleteOutletMutation, useStatusChangeMutation } = outletApi;
